import { axios } from './axios'

export const getInternalOrganizations = () => {
  return axios.get('/ace/organizations')
}
